<script setup>
import { to } from 'await-to-js';
import dayjs from 'dayjs';
//import { Edit } from '@element-plus/icons-vue'
import { onMounted, ref } from "vue";
//import { useRouter } from "vue-router";
import { interceptor } from "@dutypay/utilities";
//const createOSSCorrectionProjectForm = ref({});
//const companiesList = ref([]);
const contractDataConfirmations = ref([]);

onMounted(async() => {
  await getContractDataConfirmations(); 
})

const getContractDataConfirmations = async () => {
  const envStore = useEnvStore();
  let err, res;
    [err, res] = await to(
      interceptor.get(`${envStore.apiUrls.contractshub  }/api/v1/contract-data-confirmations/confirmed/4a5c6cd7-2edf-433b-94e9-5347d28322da`, 
      {}
      )
    );
    if (err) {
      contractDataConfirmations.value = [];
      return;
    }
    contractDataConfirmations.value = res.data.result;
}
</script>

<script>
import { useEnvStore } from "@dutypay/store-modules";
//import { to } from "await-to-js";
import { mapState } from "pinia";
export default {
  name: "ContractDataConfirmations",
  computed: {
    ...mapState(useEnvStore, ["apiUrls"]),
  },
  methods: {
    printError(err) {
      if (this.debug) {
        this.$dp.log(err);
      }
    },
    data() {
      return {
        //OSSCorrectionProjects: [],
      };
    },
  },
};
</script>

<template>
  <div>
    <h1>Bestätigungen von Vertrags-Daten</h1>
    <el-table :data="contractDataConfirmations" style="width: 100%">
      <el-table-column prop="property.value.de-DE" label="Company" style="width: 40%"/>
      <el-table-column prop="order.id" label="Auftragsnummer" style="width: 20%"></el-table-column>
      <el-table-column label="Zeitpunkt" style="width: 40%">
        <template #default="scope">
        <div style="display: flex; align-items: center">
          {{ dayjs(scope.row['property.confirmation.time']).format('DD.MM.YYYY HH:mm:ss') }}<br/>
          durch {{ scope.row['primary.email.address'] }}
        </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style scoped lang="scss">
.form-inline .el-input {
  --el-input-width: 220px;
}
</style>

<i18n>
  {
  "en-US": {
  }
  }
</i18n>
